'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('../../../../../aviary-core/dist/cjs/index.cjs');
var Badge_web_styles = require('./Badge.web.styles.cjs');
var index = require('../../../../../../_virtual/index.cjs');

/**
 * Badge Component
 * This component changes its UI based on the size passed in.
 *
 * Size - XSmall / Small - Show a dot with no counter
 *      - Medium - Show the passed in counter within the badge dot
 *
 * @defaults Size = "medium", Variant = "success"
 *
 * {@link https://aviary.supernova-docs.io/latest/components/badge/overview-8Chkb3k6 | Documentation}
 *
 * @scope Core
 */ const Badge = ({ count, size = index.__exports.BADGE_SIZES.medium, backgroundColor = index.__exports.BADGE_COLORS.success, customCss, ...rest })=>{
    const isNumberAboveZero = Number.isInteger(count) && count && count >= 0;
    const badgeStyles = [
        Badge_web_styles.badgeBase,
        Badge_web_styles.badgeSize[size],
        Badge_web_styles.badgeColor[backgroundColor],
        customCss
    ];
    const renderCountDisplay = ()=>{
        if (!isNumberAboveZero || size !== index.__exports.BADGE_SIZES.medium) return null;
        const countDisplay = count > 99 ? "99" : count;
        return /*#__PURE__*/ jsxRuntime.jsx("div", {
            css: Badge_web_styles.textWrapper,
            children: countDisplay
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: badgeStyles,
        "data-testid": "aviary-badge",
        ...rest,
        children: renderCountDisplay()
    });
};

exports.Badge = Badge;
//# sourceMappingURL=Badge.web.cjs.map
